import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { updateSeekerProfileData } from "../../API/api";
import { toast } from "react-toastify";
import { handleError } from "../../utils";
import { ExpertButton } from "../../Pages/ExpertProfilePage/StyledComponents";
import { CURRENT_ROLE } from "../../API/url";
import VizButton from "../VizButtons/VizButton";
import VizParagraph from "../VizParagraph/VizParagraph";

export default function ExpertEditProfile() {
  const dispatch = useDispatch();
  const profilePictureState = useSelector(state => state.profilePage);
  const { advanceFilterModalToggle, storeUserData } = bindActionCreators(Actions, dispatch);
  const profilePictureModal = () => {
    advanceFilterModalToggle({ bool: true, value: "profilePicture" });
  }
  const expertState = useSelector((state) => state.expertProfileData);
  const userState = useSelector((state) => state.user);
  const [firstName, setFirstName] = useState(userState.firstName);
  const [lastName, setLastName] = useState(userState.lastName);
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPasswd, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pwdInput, initValue] = useState({
    password: "",
  });
  const currentRole = localStorage.getItem('ngStorage-currentRole');
  const changeLastName = (e) => {
    setLastName(e.target.value);
  }
  const [isError, setError] = useState(null);
  const clearStateValues = (e) => {
    // ref.current.value = '';
    setConfirmPassword('');
    setCurrentPassword('')
    setError('');
    pwdInput.password = '';
    setPasswordError('');
    setCollapse(!collapse);
  }
  const [confirmPasswordError, setPasswordError] = useState(null);
  const [collapse, setCollapse] = useState(false);
  const handleCurrentPassword = (e) => {
    setCurrentPassword(e.target.value)
    if (pwdInput.password !== '' && pwdInput.password === e.target.value) {
      setError(<p style={{ color: "red", fontSize: "14px" }}>Current Password and New Password cannot be the same.</p>)
    }
    if (e.target.value === '') {
      setError(null)
    }
  }
  const onChange = (e) => {
    let password = e.target.value;
    initValue({
      ...pwdInput,
      password: e.target.value,
    });
    setError(null);
    let caps, small, num, specialSymbol, charSet;
    caps = (password.match(/[A-Z]/g) || []).length;
    small = (password.match(/[a-z]/g) || []).length;
    num = (password.match(/[0-9]/g) || []).length;
    specialSymbol = (password.match(/\W/g) || []).length;
    charSet = (password.match(/{.8,}$/g) || []).length;
    if (password.length < 8) {
      setError(
        <ul style={{ paddingTop: "5px" }}>
          {/* <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 8 characters</li> */}
          {charSet < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 8 characters</li> : <li >wrong characters</li>}
          {caps < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 1 uppercase character</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 uppercase character</li>}
          {small < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 1 lowercase character</li> : <li style={{ color: "green", listStyle: "none" }} ><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 lowercase character</li>}
          {num < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i> At least 1 number</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 number</li>}
          {specialSymbol < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 1 special character(!,@,#,$,%,_)</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>Password should contain at least one special character: @$!%*?&</li>}
        </ul>
      );
      return;
    }
    else {
      setError(
        <ul style={{ paddingTop: "5px" }}>
          <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 8 characters</li>
          {caps < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i> At least 1 uppercase character</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 uppercase character</li>}
          {small < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 1 lowercase character</li> : <li style={{ color: "green", listStyle: "none" }} ><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 lowercase character</li>}
          {num < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i> At least 1 number</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At least 1 number</li>}
          {specialSymbol < 1 ? <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 1 special character(!,@,#,$,%,_)</li> : <li style={{ color: "green", listStyle: "none" }}><i className="fa fa-check-circle" style={{ padding: "2px" }}></i>Password should contain at least one special character: @$!%*?&</li>}
        </ul>
      );
    }
    if (password === currentPassword || (currentPassword !== '' && currentPassword === password)) {
      setError(<p style={{ color: "red", fontSize: "14px" }}>Current Password and New Password cannot be the same.</p>)
    }
    if (password !== confirmPasswd && confirmPasswd !== '') {
      setPasswordError(<p style={{ color: "red", fontSize: "14px" }}>Passwords don't match</p>)
    }
    if (password === confirmPasswd && confirmPasswd !== '') {
      setPasswordError(<p style={{ color: "green", fontSize: "14px" }}>Password Confirmed</p>)
    }
  };
  const changeFirstName = (e) => {
    setFirstName(e.target.value);
  }
  const [isStrong, initRobustPassword] = useState(null);
  const initPwdInput = async (childData) => {
    initRobustPassword(childData);
  };
  const StrengthMeter = (props) => {
    const pwdValidate = props.password;
    const initPwdChecker = (
    ) => {
      let pwdCheck = 0;
      let validateRegex = ["[A-Z]", "[a-z]", "[0-9]", "\\W"];
      validateRegex.forEach((regex, i) => {
        if (new RegExp(regex).test(pwdValidate)) {
          pwdCheck += 1;
        }
      });
      switch (pwdCheck) {
        case 0:
          return {
            strength: 0,
            val: "",
          };
        case 1:
          return {
            strength: 20,
            val: "Weak",
          };
        case 2:
          return {
            strength: 40,
            val: "Fair",
          };
        case 3:
          return {
            strength: 60,
            val: "Good",
          };
        case 4:
          return {
            strength: 80,
            val: "Strong",
          };
        case 5:
          return {
            strength: 100,
            val: "Excellent",
          };
        default:
          return null;
      }
    };
    {props.actions(initPwdChecker().val)}

    return (
      <>
        <div className="wrapper">
          <progress
            className={`pwd-checker-bar strength-${initPwdChecker().val}`}
            value={initPwdChecker().strength}
            max="100"
          />
          <br />
          <p className="pwd-label">
            {props.password && (
              <div>
                <p className={`label strength-${initPwdChecker().val}`}>
                  <strong style={{ padding: "3px" }}>{initPwdChecker().val}</strong>
                </p>
              </div>
            )}
          </p>
        </div>
      </>
    )
  };
  const ref = useRef(null);
  const onSubmit = (e) => {
    e.preventDefault();
    // e.persist();
    // const payloadData = {
    //   confirmPassword: confirmPasswd,
    //   currentPassword: currentPassword,
    //   firstName: firstName,
    //   lastName: lastName,
    //   newPassword: pwdInput.password,
    //   outOfOffice: [],
    //   questionShared: userState.expertAnswered,
    // }
    let payloadForCM = {
      firstName: firstName === "" ? userState.firstName : firstName,
      lastName: lastName === "" ? userState.lastName : lastName,
      currentPassword: currentPassword,
      newPassword: pwdInput.password,
      confirmPassword: confirmPasswd,
      newQuestion: userState.newQuestion,
      seekerRated: userState.seekerRated,
      questionShared: userState.questionShared,
      anotherExpertAnswered: userState.anotherExpertAnswered,
      newExpQuestion: userState.newExpQuestion,
      ...(CURRENT_ROLE === 'Expert' && {outOfOffice:[]})
    }
    updateSeekerProfileData(payloadForCM).then((res) => {
      if (res===undefined) return;
      if (res.data.data !== '' && res.data.success) {
        userState.firstName = payloadForCM.firstName;
        userState.lastName = payloadForCM.lastName;
        // setIsSubmitting(true);
        let newObj = {...userState}
        storeUserData(newObj);
        clearStateValues();
        // localStorage.setItem('ngStorage-firstName', JSON.stringify(userState.firstName));
        // localStorage.setItem('ngStorage-lastName', JSON.stringify(userState.lastName));
        if (collapse === true) {
          setCollapse(!collapse)
        }
        else {
          setCollapse(collapse)
        }
        toast.success(toggleButtonToast(), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      if (res.data.success === false || res.data.data === undefined) {
        handleError(res.data.message)
      }
    }).catch((err) => handleError(err))
  };
  const toggleButtonToast = () => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          Profile has been updated.
        </span>
      </>
    );
  };
  const handleConfirmPassword = (e) => {
    // e.persist();
    setConfirmPassword(e.target.value);
    if (pwdInput.password !== e.target.value) {
      setPasswordError(<p style={{ color: "red", fontSize: "14px" }}>Passwords don't match</p>)
    }
    if (pwdInput.password === e.target.value) {
      setPasswordError(<p style={{ color: "green", fontSize: "14px" }}>Password Confirmed</p>)
    }
    if (e.target.value === '') {
      setPasswordError(null);
    }
    if (pwdInput.password === '' || pwdInput.password.length === 0) {
      setPasswordError(null)
    }
  }

  return (
    <>
      <div className="profileInfo">
        <div className="row">
          <div className="col-lg-3 col-xl-3 col-sm-12 col-xs-12 text-center pb-3">
            <img alt="Profile Icon" src={profilePictureState.profilePic || require("../../Images/cliente.png")} style={{ minWidth:"125px",maxWidth: "125px", marginBottom: "15px", height: "125px" }} />
            {/* <button className="button btn-warning updateProfile" onClick={() => profilePictureModal()}>Update Picture</button> */}
            {/* <ExpertButton onClick={() => profilePictureModal()}>Update Picture</ExpertButton> */}
            {CURRENT_ROLE !== 'CM' && <button
              className="button btn btn-warning updateProfile"
              onClick={() => profilePictureModal()}
            >
              Update Picture
            </button>}
            {
              CURRENT_ROLE === 'CM' && 
              <div style={{textAlign:'center'}}>
              <VizButton size={3} type={"Primary"} onClick={profilePictureModal}>Update Picture</VizButton>
              </div>
            }
          </div>
          <div className="col-lg-9 col-xl-9 col-sm-12 col-xs-12">
            <Form autoComplete="off">
              <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
                {CURRENT_ROLE !== 'CM' && <Form.Label className="labelName col-sm-3">First Name<span className="iconsRed">*</span></Form.Label>}
                {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>First Name<span className="iconsRed">*</span></VizParagraph></Form.Label>}
                <div className="col-sm-6" style={{
                  marginLeft: "12px"
                }}>
                  <input type="text" autoComplete="off" className="form-control inputField" value={firstName} style={{ fontSize: "14px" }} onChange={(e) => changeFirstName(e)}></input>
                </div>
              </Form.Group>
              <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
              {CURRENT_ROLE !== 'CM' && <Form.Label className="labelName col-sm-3">Last Name<span className="iconsRed">*</span></Form.Label>}
              {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>Last Name<span className="iconsRed">*</span></VizParagraph></Form.Label>}
                <div className="col-sm-6" style={{
                  marginLeft: "12px"
                }}>
                  <input type="text" autoComplete="something" value={lastName} className="form-control inputField" onChange={(e) => changeLastName(e)} style={{ fontSize: "14px" }} ></input>
                </div>
              </Form.Group>
              <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
              {CURRENT_ROLE !== 'CM' && <Form.Label className="labelName col-sm-3">Email</Form.Label>}
              {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>Email</VizParagraph></Form.Label>}

                <div className="col-sm-6" style={{
                  marginLeft: "12px"
                }}>
                  <input disabled type="text" className="form-control inputField" value={userState.email} style={{ cursor: "not-allowed", fontSize: "14px" }}></input>
                </div>
              </Form.Group>
              <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
                <Form.Label type="button" className="labelPassword col-sm-3" onClick={(e) => clearStateValues(e)}>Change Password</Form.Label>
              </Form.Group>
              {/* {collapse ? null : <button style={{ transition: collapse ? '.7s ease-in-out' : 'none' }} className="saveButton" disabled={firstName.trim().length === 0 || lastName.trim().length === 0 || (userState.firstName === firstName && userState.lastName === lastName) ? true : false} onClick={(e) => onSubmit(e)}>Save</button>} */}
              {collapse  ?
               null :
                <>
                {
                  CURRENT_ROLE === 'CM' ?  
                <>
                <div style={{float:'right'}}>
                {
                  firstName.trim().length === 0 || 
                  lastName.trim().length === 0 || 
                  (userState.firstName === firstName && userState.lastName === lastName) 
                  ?
                  <VizButton size={3} type={"Disabled"}>Save</VizButton>
                  :
                  <VizButton size={3} type={"Primary"} onClick={onSubmit}>Save</VizButton>
                }
                </div>
                </>
                :
                <ExpertButton sx={{ float: "right" }} disabled={firstName.trim().length === 0 || lastName.trim().length === 0 || (userState.firstName === firstName && userState.lastName === lastName) ? true : false} onClick={(e) => onSubmit(e)}>Save</ExpertButton>}</>}
              {collapse && <>
                <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
                  {CURRENT_ROLE !== 'CM' &&<Form.Label className="labelName col-sm-3">Current Password</Form.Label>}
                  {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>Current Password:</VizParagraph></Form.Label>}
                  <div className="col-sm-6" style={{
                    marginLeft: "12px"
                  }}>
                    <div style={{ display: "flex" }}>
                      <input type="password" autoComplete="new-password" value={currentPassword} onChange={(e) => handleCurrentPassword(e)} className="form-control inputField" style={{ fontSize: "14px" }} />
                      {/* {confirmPasswordError} */}
                    </div>
                  </div>
                </Form.Group>
                <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
                  {CURRENT_ROLE !== 'CM' &&<Form.Label className="labelName col-sm-3">New Password</Form.Label>}
                  {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>New Password:</VizParagraph></Form.Label>}
                  <div className="col-sm-6" style={{
                    marginLeft: "12px"
                  }}>
                    <input autoComplete="off" ref={ref} type="password" className="form-control inputField" style={{ fontSize: "14px" }} value={pwdInput.password} onChange={(e) => onChange(e)}></input>
                    {(isError !== null && pwdInput.password !== '' && pwdInput.password !== confirmPasswd) && <p className="errors">  {isError}</p>}
                  </div>
                </Form.Group>
                {((pwdInput.password !== '' || pwdInput.password.length !== 0) && pwdInput.password !== currentPassword) && <StrengthMeter password={pwdInput.password} actions={initPwdInput} />}
                <Form.Group style={{ display: "flex", marginBottom: "15px" }}>
                  {CURRENT_ROLE !== 'CM' && <Form.Label className="labelName col-sm-3">Confirm New Password</Form.Label>}
                  {CURRENT_ROLE === 'CM' && <Form.Label className="labelName col-sm-3"><VizParagraph type={5} weight={1}>Confirm New Password:</VizParagraph></Form.Label> }
                  <div className="col-sm-6" style={{
                    marginLeft: "12px"
                  }}>
                    <input type="password" autoComplete="off" value={confirmPasswd} onChange={(e) => handleConfirmPassword(e)} className="form-control inputField" style={{ fontSize: "14px" }}></input>
                    {pwdInput.password !== '' && confirmPasswordError}
                  </div>
                </Form.Group>
                {CURRENT_ROLE !== 'CM' &&<Form.Group>
                  <ExpertButton sx={{ float: "right" }} onClick={(e) => onSubmit(e)} disabled={(firstName.trim().length === 0 || firstName.trim() === '') || (lastName.trim().length === 0 || lastName.trim() === '') || (pwdInput.password === '' || pwdInput.password.length < 8) || (isStrong === "Good" || isStrong === "Weak" || isStrong === "Fair") || (isSubmitting === true) || (pwdInput.password !== confirmPasswd) || (pwdInput.password === currentPassword) || (currentPassword === '' || currentPassword.length === 0) ? true : false}>Save</ExpertButton>
                </Form.Group>}
                {
                  CURRENT_ROLE === 'CM' && 
                  <Form.Group style={{float:'right'}}>
                      {
                        ((firstName.trim().length === 0 ||
                          firstName.trim() === '') ||
                        (lastName.trim().length === 0 ||
                          lastName.trim() === '') ||
                        (pwdInput.password === '' ||
                          pwdInput.password.length < 8) ||
                        (isStrong === "Good" ||
                          isStrong === "Weak" || isStrong === "Fair") ||
                        (isSubmitting === true) ||
                        (pwdInput.password !== confirmPasswd) ||
                        (pwdInput.password === currentPassword) ||
                        (currentPassword === '' ||
                          currentPassword.length === 0)) ? 
                          <VizButton size={3} type={"Disabled"}>Save</VizButton>
                          : <VizButton onClick={onSubmit} size={3} type={"Primary"}>Save</VizButton>
                      }
                  </Form.Group>
                }
              </>}
            </Form>
          </div>
        </div>
      </div>
    </>
  )
}